import { render, staticRenderFns } from "./PhotoQuickLinks.vue?vue&type=template&id=6316a232"
import script from "./PhotoQuickLinks.vue?vue&type=script&lang=js"
export * from "./PhotoQuickLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports